const constructVideoSchema = ({
  id,
  name,
  description,
  thumbnailUrl,
  uploadDate
}) => {
  return JSON.stringify({
    '@context': 'https://schema.org',
    '@type': 'VideoObject',
    '@id': id,
    thumbnailUrl: [thumbnailUrl],
    name,
    description,
    uploadDate
  })
}

const extrapolateVideoSchemas = (components) => {
  const videoContentList = components.reduce((prev, component) => {
    const isPageContent = component.type === 'PageContent'
    if (!isPageContent) {
      return prev
    }

    const videoContentList = component?.props?.content?.filter((contentItem) => contentItem.type === 'video') ?? []
    return [...prev, ...videoContentList]
  }, [])

  return videoContentList.map((videoContent) => constructVideoSchema({
    id: videoContent.id,
    name: videoContent.props.videoName,
    thumbnailUrl: videoContent.props.videoThumbnail,
    description: videoContent.props.videoAlt,
    uploadDate: videoContent.props.videoUploadDate
  }))
}

export default extrapolateVideoSchemas
